import dstyled from 'astroturf';
import React from 'react';

function InlineCode(props) {
  return /*#__PURE__*/React.createElement("code", props);
}

export default /*#__PURE__*/dstyled(InlineCode, null, {
  displayName: "InlineCode",
  styles: require("./InlineCode.module.css"),
  attrs: null,
  vars: []
});